module.exports = __webpack_public_path__ + "media/images/konintodoke/top_mv/konintodoke00002-451227254db7afba5158979a8e5d72eb.jpg";